<template>
  <div>
    <headerView ></headerView>
    <div id="curpageWidth">
      <div v-loading="listLoading">

        <div
          v-for="(item, index) in pageModule"
          :key="index"
          style="position: relative"
          :ref="'pageItem'+index"
          :id="'sub_'+item.WID"
        >
       
          <component
            v-bind:is="item.ModuleName"
            v-bind:modata="item"
            type="preview"
            :phone-width="phoneWidth"
            :curpage-width="curpageWidth"
            :proportion="proportion"
            :animate-show="animateClas[index]"
            v-bind:index="index"
            :key="item.WID"
          ></component>
        </div>
      </div>
    </div>
    <el-empty :image-size="160" :description="$t('nodata')" v-if="stateSche==2 || stateSche==3"></el-empty>
    <footView v-if="stateSche!=1"></footView>
  </div>
</template>

<script>
import 'animate.css';//https://animate.style/  
import { getPage,getPageHome,getPageWxHome } from "@/request/api";

import hotpotModule from "@/components/Custom/Hotpot";
import mediumModule from "@/components/Custom/Medium";
import sliderModule from "@/components/Custom/Slider";
import spaceModule from "@/components/Custom/Space";
import textModule from "@/components/Custom/Text";
import videoModule from "@/components/Custom/Video";
 import courseModule from "@/components/Custom/Course";

import aboutModule from "@/components/Custom/AboutUs";
import titleModule from "@/components/Custom/Title";
import txtInfoModule from "@/components/Custom/TxtInfo";
import introModule from "@/components/Custom/Intro";
import mediaTextModule from "@/components/Custom/MediaTextBlock";
import newsModule from "@/components/Custom/News";
import slider2Module from "@/components/Custom/Slider2";
import summaryModule from "@/components/Custom/SummaryCard";
import tablistModule from "@/components/Custom/Tablist";
import course2Module from "@/components/Custom/Course2";
import globalModule from "@/components/Custom/Global";
 import imgInfoModule from "@/components/Custom/ImgInfo";
 import videoListModule from "@/components/Custom/VideoList";

 import summaryBriefModule from "@/components/Custom/SummaryBrief";
  import aboutImgModule from "@/components/Custom/AboutImg";
  import techShowModule from "@/components/Custom/TechShow";
  import corporateValuesModule from "@/components/Custom/CorporateValues";
  import companyOverviewModule from "@/components/Custom/CompanyOverview";
  import opticalRndModule from "@/components/Custom/OpticalRnd";
  import timelineModule from "@/components/Custom/Timeline";
  import globalRndModule from "@/components/Custom/GlobalRnd";
  import breadcrumbModule from "@/components/Custom/Breadcrumb";
  import lightBannerModule from "@/components/Custom/LightBanner";

export default {
  name: "",
  components: {
    hotpotModule,
    mediumModule,
    sliderModule,
    spaceModule,
    textModule,
    videoModule,
    courseModule,
     aboutModule, titleModule, txtInfoModule,
     introModule, mediaTextModule, newsModule, slider2Module, summaryModule, tablistModule, course2Module,imgInfoModule,
     globalModule,videoListModule,

     summaryBriefModule,aboutImgModule,techShowModule,corporateValuesModule,companyOverviewModule,opticalRndModule,timelineModule,globalRndModule,breadcrumbModule,lightBannerModule
   },
  data() {
    return {
      pageID: "",
      stateSche: 1,
      listLoading: true,
      pageModule: null,
      
      phoneWidth: 0,
      curpageWidth: 1280,
      proportion:1,


      innerHeight:0,
      animateClas:[],
      itemBottom:[],
    };
  },
  mounted() {
   this.innerHeight=window.innerHeight;

    this.curpageWidth =document.getElementById("curpageWidth").offsetWidth - 17;
    this.pageID=this.$route.params && this.$route.params.id;
    this.getDataList();

  },
  created() {

  },
   beforeDestroy() {
     window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route.params.id': {
      immediate: false,
      handler(newId, oldId) {
        if (newId === oldId) return
        this.pageID = newId
        this.getDataList()
      }
    }
  },
  methods: {
    getDataList() {
      let that = this;
      const reqId = this.pageID
      that.stateSche = 1;
      that.listLoading = true;
      let handleGet;
      if ((this.$route.query && this.$route.query.type=="wxpage")||(window.navigator && window.navigator.userAgent.indexOf("miniProgram")>=0)) {
        handleGet=getPageWxHome("");//微信小程序进入
      }else{
        handleGet=that.pageID?getPage("id=" + that.pageID):getPageHome("");
      }

      handleGet.then((res) => {
        if (reqId !== that.pageID) return
        that.listLoading = false;
        if (res.code == 200) {
          let data = res.data;
          let pageJson = data.pageJson ? JSON.parse(data.pageJson) : {};
          that.phoneWidth = pageJson.phoneWidth;

          that.proportion= Math.round((that.curpageWidth/that.phoneWidth) * 100) / 100;

          that.pageModule = pageJson.pageList || {};

          document.title = data.title;
          let metaInfo={
            keywords:data.seoKeyWord,
            description: data.seoDescription,
          };

          that.$store.commit("CAHNGE_META_INFO",metaInfo)

          that.$nextTick(()=>{
            if (!that.pageModule) return
            that.itemBottom = []
            that.pageModule.forEach((item,index)=>{
              const ref = that.$refs['pageItem'+index]
              if (ref && ref[0]) {
                that.itemBottom.push(ref[0].offsetTop || 0)
              }
            })
            that.handleScroll();

            // hash 锚点滚动兜底(数据加载完后,再次尝试)
            if (that.$route.hash) {
              that.$nextTick(() => {
                const el = document.querySelector(that.$route.hash)
                if (el) {
                  const headerEl = document.querySelector('header')
                  const headerHeight = headerEl ? headerEl.offsetHeight : 0
                  const top = el.getBoundingClientRect().top + window.scrollY - headerHeight
                  window.scrollTo({ top: Math.max(0, top), })// behavior: 'smooth'
                }
              })
            }
            
          })

          window.addEventListener('scroll', this.handleScroll,true);

          that.stateSche = 0;
        } else if (res.code == 204) {
          that.pageModule = null;
          that.stateSche = 2;
        } else {
          that.pageModule = null;
          that.stateSche = 3;
        }
      });
    },

     handleScroll(){
       let that=this;
        let itemBottom=this.itemBottom;
        let len=itemBottom.length
        if(this.animateClas.length==len){
          window.removeEventListener('scroll', this.handleScroll);
          return
        }
        const seatNumb=(window.scrollY || document.documentElement.scrollTop)+this.innerHeight +20;
        for(let i=0;i<len;i++){
          if(itemBottom[i]<seatNumb){
            that.$set(that.animateClas,i,"animate")
          }
        }
    },


  },

  destroyed(){
   this.$store.commit("CAHNGE_META_INFO",{})
  },
};
</script>

<style scoped lang="scss">

</style>